import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#0A1121",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.128 17.038a5.36 5.36 0 0 0-1.894-2.87A5.27 5.27 0 0 0 10 13.058c-1.17 0-2.307.39-3.235 1.11a5.36 5.36 0 0 0-1.894 2.87"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#0A1121",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 10C19-2 1-2 1 10s18 12 18 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#0A1121",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.998 10.811c1.939 0 3.03-1.1 3.03-3.058s-1.091-3.059-3.03-3.059S6.97 5.796 6.97 7.754s1.09 3.057 3.028 3.057"
    }, null, -1)
  ]))]))
}
export default { render: render }